import LegacyProductPage from "./LegacyProductPage";

export default LegacyProductPage;
